import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.shared-accounts', {
        url: '/shared',
        views: {
            '': 'userShared',
            'header@user': 'userSharedAccountsHeader',
        },
     
    })
}





// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/users-shared.state.js